
<icc-select-box
  [title]="'PLEATED_BLIND|Tkanina' | translate"
  [description]="selectedMainFabric?.name + ' ' + '(' + selectedMainFabric?.color?.name + ')'"
  [buttonText]="'INTERFACE|Zmień' | translate"
  [buttonText2]="'INTERFACE|Opcje' | translate"
  (select)="selectMainFabric()"
  (select2)="changeMainFabricColor(selectedMainFabric)"
></icc-select-box>


@if ((selectedVariant$ | async )?.double_fabric) {
  <icc-select-box
    [title]="'PLEATED_BLIND|Tkanina dodatkowa' | translate"
    [description]="selectedAdditionalFabric?.name + ' ' + '(' + selectedAdditionalFabric?.color?.name + ')'"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="selectAdditionalFabric()"
    (select2)="changeAdditionalFabricColor(selectedAdditionalFabric)"
  ></icc-select-box>
}

<icc-select-box
  [title]="'PLEATED_BLIND|Kolor profili' | translate"
  [description]="(selectedProfilesColor$ | async)?.name"
  [color]="'#' + (selectedProfilesColor$ | async)?.color"
  [imageUrl]="'/files/windowcolor/' + (selectedProfilesColor$ | async)?.color_img"
  [buttonText]="'INTERFACE|Zmień' | translate"
  [colorSelect]="true"
  (select)="changeProfilesColor()"
></icc-select-box>


